module.exports = __webpack_public_path__ + "static/SD47-1a72d795a8e2e70678b0c8b77c562ffb.png";